/**
 * O que a pilha mostra e o que ela anuncia — sem React, para ser testável.
 */

import type { Notificacao } from '@cliqcrm/contracts';
import type { Me } from '@cliqcrm/contracts';
import { podeNaSessao } from '@/shared/sessao/contexto';

/**
 * Os cards à vista, das mais novas para trás, e quantos ficaram esperando.
 *
 * Fora: o que a pessoa já dispensou nesta aba, e o que é da conversa que ela
 * está lendo — ali a mensagem aparece na própria conversa.
 */
export function visiveisNaPilha(
  itens: readonly Notificacao[],
  dispensadas: ReadonlySet<string>,
  conversaNaTela: string | null,
  maximo: number,
): { readonly visiveis: readonly Notificacao[]; readonly restantes: number } {
  const pendentes = itens.filter((n) => !dispensadas.has(n.id) && n.conversa_id !== conversaNaTela);
  return {
    visiveis: pendentes.slice(0, maximo),
    restantes: Math.max(0, pendentes.length - maximo),
  };
}

/**
 * As que ainda não foram anunciadas, da MAIS ANTIGA para a mais nova.
 *
 * A API devolve das mais novas para trás; o sistema operacional empilha na
 * ordem em que recebe. Anunciar na ordem da API deixaria a mensagem mais
 * antiga no topo da central de notificações.
 */
export function novasParaAnunciar(
  itens: readonly Notificacao[],
  jaAnunciadas: ReadonlySet<string>,
): readonly Notificacao[] {
  return itens.filter((n) => !jaAnunciadas.has(n.id)).reverse();
}

/**
 * Quem lê conversa recebe o card: `conversa × ler` do `/v1/me`, já com os
 * ajustes da pessoa (#732).
 *
 * O custo de errar para o lado de mais não é só um card a mais: a assinatura
 * `notificacao:eu` de quem não lê conversa é recusada, e o servidor recusa o
 * fluxo inteiro, o que derruba o tempo real das outras telas junto. A Operação
 * Cliqfy é o caso de sempre: ela não lê conteúdo sem step-up (§13.2).
 */
export function recebeNotificacao(me: Pick<Me, 'permissoes'> | null | undefined): boolean {
  return podeNaSessao(me, 'conversa', 'ler');
}
